<template>
  <AppHeader>View Subscription</AppHeader>

  <Loading v-if="state == 'loading'"></Loading>

  <div v-if="state == 'idle'" class="p-4">
    <div class="p-3 text-gray-600 bg-white shadow rounded-2xl">
      <p class="text-xl text-gray-900">{{ subscription.customer.name }} <small>(#{{ subscription.customer.id }})</small></p>
      <p class="mt-2 text-xl text-gray-900">{{ subscription.product.name }} ({{ subscription.product.quantity }}) <small>(#{{ subscription.id }})</small></p>
      <p class="mt-2 text-lg">{{ subscription.quantity }} Nos | {{ subscription.type.toUpperCase() }} | {{ subscription.status.toUpperCase() }}</p>
      <p class="mt-2 text-lg">{{ toDate(subscription.start_date) }} <i class="px-2 text-sm ion-md-arrow-forward"></i> {{ toDate(subscription.end_date) }}</p>
      <p class="mt-1">{{ subscription.notes }}</p>

      <p class="mt-4">Created At : <b>{{ toDate(subscription.created_at, true) }}</b></p>
      <p class="mt-2">Activated At : <b>{{ toDate(subscription.activated_at, true) }}</b></p>
      <p class="mt-2">Paused At : <b>{{ toDate(subscription.paused_at, true) }}</b></p>
      <p class="mt-2">Unpaused At : <b>{{ toDate(subscription.unpaused_at, true) }}</b></p>
      <p class="mt-2">Completed At : <b>{{ toDate(subscription.completed_at, true) }}</b></p>
      <p class="mt-2">Cancelled At : <b>{{ toDate(subscription.cancelled_at, true) }}</b></p>
    </div>

    <p class="mt-5 text-lg text-gray-500">Deliveries</p>
    <div class="mt-2 responsive-table">
      <table>
        <thead>
          <tr>
            <th>Date</th>
            <th>Status</th>
            <th>Empty Bottle</th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="del in subscription.deliveries" :key="del.id" :class="{'bg-red-300': del.status == 'not_delivered'}">
            <td>{{ toDate(del.date) }}</td>
            <td>{{ del.status.toUpperCase() }}</td>
            <td>{{ del.returned_bottle ? 'Returned' : 'Not Returned' }}</td>
          </tr>

          <tr v-if="subscription.deliveries.length == 0">
            <td class="text-xl text-center text-gray-500" colspan="100%">No Deliveries</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import mixin from '@/utils/mixin';
import AppHeader from '@/components/common/Header.vue';
import Loading from '@/components/common/Loading.vue';

export default {
  name: 'ViewSubscription',
  mixins: [ mixin ],
  components: { AppHeader, Loading },
  data() {
    return {
      state: 'loading',
      subscription: { deliveries: [] },
    }
  },

  methods: {
    getSubscription() {
      this.state = 'loading';

      this.request('GET', 'subscriptions/' + this.$route.params.id, {}, (resp) => {
        this.state = 'idle';
        if (!resp.success) alert(resp.message ? resp.message : 'Unable to fetch details, please try again.');
        else this.subscription = resp.data;
      });
    },
  },

  created() {
    if (!this.$route.params.id) this.$router.go(-1);
    else this.getSubscription();
  }
}
</script>
